import React from "react";

const Topic = (props) => {
  return (
    <div className="row align-items-center">
    <div className="col-12 text-center">
        <div className="section-title" style={{marginBottom: '40px'}}>
            <span className="revamp-section-badge" style={{marginBottom: '25px', display: 'inline-block'}}>{props.head}</span>
            <h2 className="revamp-section-title">{props.info}</h2>
        </div>
    </div>
</div>
  );
};

export default Topic;